import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { DashboardContainer } from "../../../../components"

import { useAppNotificationStore } from "../../../../stores"
import BankAccountInfo from "./BankForm/BankAccountInfo"

type FlowIndicator = {
  index: number
  title: string
  current: boolean
  completed: boolean
}
const CompanyVerification: React.FC<{ onSuccess?: () => void }> = ({
  onSuccess,
}) => {
  return (
    <DashboardContainer>
      <div className="w-full mx-auto flex flex-col gap-4">
        <div className="w-full h-full">
          <BankAccountInfo onSuccess={onSuccess} />
        </div>
      </div>
    </DashboardContainer>
  )
}

export default CompanyVerification
